import { useTranslation } from 'react-i18next'
import { ExternalInsurerLogo } from '@/features/CrossSell/components/ExternalInsurerLogo/ExternalInsurerLogo'
import { type FetchedExternalInsuranceFragment } from '@/services/graphql/generated'
import { Card } from 'ui/src/components/Card/Card'
import { BaseDialog } from 'ui/src/components/Dialog/BaseDialog'
import { yStack } from 'ui/src/patterns/stack'

type FetchedInsurancesContentProps = {
  insurances: Array<FetchedExternalInsuranceFragment>
}

export function FetchedInsurancesContent({ insurances }: FetchedInsurancesContentProps) {
  const { t } = useTranslation('purchase-form')
  const externalInsurerName = insurances[0]?.insurer.displayName?.trim() ?? ''

  return (
    <>
      <div>
        <BaseDialog.Title>{t('FETCHED_INSURANCES_DIALOG_TITLE', { count: insurances.length })}</BaseDialog.Title>
        {externalInsurerName ? (
          <BaseDialog.Description>
            {t('FETCHED_INSURANCES_DIALOG_DESCRIPTION', { externalInsurerName })}
          </BaseDialog.Description>
        ) : null}
      </div>

      <ul className={yStack({ gap: 'xs' })}>
        {insurances.map((insurance, index) => (
          <Card.Root key={index} variant="secondary" size="md" asChild>
            <li>
              <Card.Header>
                <Card.Media>
                  <ExternalInsurerLogo
                    insurelyId={insurance.insurer.insurelyId}
                    displayName={insurance.insurer.displayName}
                  />
                </Card.Media>
                <Card.Heading>
                  <Card.Title>{insurance.displayName}</Card.Title>
                  {insurance.subtitle && <Card.Subtitle>{insurance.subtitle}</Card.Subtitle>}
                </Card.Heading>
              </Card.Header>
            </li>
          </Card.Root>
        ))}
      </ul>
    </>
  )
}
